import { pctExplicitoParaProduto } from './motor'
import type { ComissaoPercentual, Produto, RegraComissao } from '../db/tipos'

// Um produto está "com comissão pendente" numa regra por item quando não tem
// percentual explícito (produto/linha/categoria) — cairia no fallback (pct_padrao).
//
// Regra "% fixo" não gera pendência POR PRODUTO: ela não usa percentuais por
// produto (motor.ts devolve pct_padrao direto). Uma pct_fixo sem percentual é
// um defeito da REGRA, não dos produtos, e tem remédio próprio — ver
// regraSemPercentual em planoTabela.ts.
export function comissaoPendente(
  regra: RegraComissao,
  percentuais: ComissaoPercentual[],
  produto: Produto,
): boolean {
  if (regra.tipo !== 'pct_por_item') return false
  return pctExplicitoParaProduto(regra, percentuais, produto) === null
}


// Uma regra "% fixo" só cobre os produtos quando tem percentual: sem ele o
// motor faz `pct_padrao ?? 0` (motor.ts:46) e TUDO que ela governa paga zero em
// silêncio. A spec original errou ao afirmar "pct_fixo cobre todos os produtos
// por definição". Zero EXPLÍCITO continua válido — é escolha, não esquecimento.
export function regraPagaZeroEmSilencio(regra: RegraComissao): boolean {
  return regra.tipo === 'pct_fixo' && regra.pct_padrao === null
}

export interface AlvoPendente {
  produtoId: string
  codigo: string
  descricao: string
}

export function paraAlvoPendente(produto: Produto): AlvoPendente {
  return { produtoId: produto.id, codigo: produto.codigo, descricao: produto.descricao }
}

// Recebe apenas os produtos VENDAVEIS pela regra (com preco vivo numa tabela
// que ela governa). Passar o catalogo inteiro da marca inflava o contador e
// gerava alarme falso — ver B4 da spec 2026-07-21-comissao-obrigatoria.
export function pendenciasDeComissao(
  regra: RegraComissao,
  percentuais: ComissaoPercentual[],
  produtosComPreco: Produto[],
): AlvoPendente[] {
  if (regra.tipo !== 'pct_por_item') return []
  return produtosComPreco
    .filter((produto) => comissaoPendente(regra, percentuais, produto))
    .map(paraAlvoPendente)
}
